export default class BackEndService {

    serverUrl: string;
    token: string;

    constructor(baseUrl: string, token: string) {
        this.serverUrl = baseUrl;
        this.token = token;
    }

    async get(path: string, params: {} | null,): Promise<any> {
        return this.request("GET", path, params, null)
    }

    async post(path: string, params: {} | null, data: {} | null,): Promise<any> {
        return this.request("POST", path, params, data)
    }

    async request(method: string, path: string, params: {} | null, data: {} | null,): Promise<any> {
        let url = this.serverUrl
        let body = data;

        let headers: any = {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Application': this.token
            },

        }

        if (method === "POST") {
            headers.body = JSON.stringify(body);
        }

        // console.log("Base url: " + url)
        // console.log(JSON.stringify(headers, null, 2))
        // console.log(JSON.stringify(body, null, 2))

        return fetch(url + path, headers)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson) {
                    return responseJson
                }

                return { error: [{ message: "Something went wrong" }] }
            })
    }
}